import { useEffect, useState } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const useRepStats = (token, period) => {
  const [data, setData] = useState(null);
  useEffect(() => {
    if (!token) return;
    fetch(`${API_URL}/api/sales/leaderboard?period=${period}`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => r.json())
      .then(setData)
      .catch(() => setData(null));
  }, [token, period]);
  return data;
};

export const PeriodToggle = ({ period, setPeriod }) => (
  <div className="flex rounded-lg border border-slate-200 p-0.5 bg-slate-50" data-testid="stats-period-toggle">
    {[['month', 'This Month'], ['all', 'All Time']].map(([v, l]) => (
      <button
        key={v}
        type="button"
        onClick={() => setPeriod(v)}
        className={`px-3 py-1 text-xs font-medium rounded-md transition-colors ${period === v ? 'bg-white text-slate-900 shadow-sm' : 'text-slate-500 hover:text-slate-700'}`}
        data-testid={`stats-period-${v}`}
      >
        {l}
      </button>
    ))}
  </div>
);
